import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HomeDelivery } from '../../models/home-delivery';
import { Transport } from '../../models/transport';
import { EventService } from '../../services/event.service';
import { TourService } from '../../services/tour.service';
import { Subscription } from 'rxjs';
import { ConfigService } from "../../services/config.service";

@Component({
  selector: 'app-info-bar',
  templateUrl: './info-bar.component.html',
  styleUrls: ['./info-bar.component.scss']
})
export class InfoBarComponent implements OnInit, OnDestroy {

  @Input() transport: Transport;
  @Input() homeDelivery: HomeDelivery;

  isLoading = false;
  isLoadingSubscription: Subscription;
  hideItemsBar = false;

  constructor(
    private events: EventService,
    private changeDetectorRef: ChangeDetectorRef,
    private tourService: TourService,
    private config: ConfigService
  ) {
    this.hideItemsBar = this.config.hideItemsBar;
  }

  ngOnInit(): void {
    this.isLoadingSubscription = this.events.isLoading.subscribe(isLoading => {
      this.isLoading = isLoading;
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.isLoadingSubscription.unsubscribe();
  }

  /**
   * The tour code that should be shown, or a placeholder ("-") if no tour is available
   */
  get tourCode(): string {
    return this.tourService.tourName || '-';
  }
}
